import TranslationText from '@Components/Utilities/TranslationText';
import { listingAlertSpecNamesToCheck, topLevelClassificationsToSkipLowerClassifications } from '@Components/Utilities/SandhillsConstants';
import RadioButtonList from '@Components/Shared/Controls/RadioButtonList';
import Toggle from '@Components/Shared/Controls/Toggle';
import { sandhillsRequest, truncateString } from '@Components/Utilities/SandhillsUtility';
import translator from '@Components/Utilities/Translator';
import SelectField from '@Components/Shared/Controls/SelectField';
import TextField from '@Components/Shared/Controls/TextField';
import { useWindowSize } from '../Utilities/WindowSize';
import { UnformatCurrency } from '@Components/Utilities/CurrencyFormatter';
import { useState, useEffect, useCallback, useRef } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { debounce } from 'lodash';

const EmailAlertsInputForm = (props) => {
    const getTopSelectedClassificationLabel = (classificationID) => {
        if (siteHasClassifications) {
            let selectedTopClassification = props.SelectListItems && props.SelectListItems.TopClassificationOptions ? props.SelectListItems.TopClassificationOptions.find((c) => { return c.Value == classificationID }) : null;
            if (selectedTopClassification && selectedTopClassification.length > 0) {
                return selectedTopClassification[0].Text;
            }
        }
        return '';
    };
    const checkForExpansionValues = () => {
        if (alertData.YearFrom || alertData.YearTo || alertData.HoursMax || alertData.HoursMin || alertData.PriceLimit || alertData.UserEnteredLocation || alertData.HorsepowerMin || alertData.HorsepowerMax || alertData.LengthInFeet || alertData.LengthInInches || alertData.MileageMin || alertData.MileageMax || alertData.Engine || alertData.WidthInInches || alertData.EmailAlertsForSale || alertData.EmailAlertsForAuction) {
            return true;
        }
        return false;
    }
    const maxLength = 21;
    const windowSize = useWindowSize();
    const [displayExpansion, setDisplayExpansion] = useState(props.WantToBuyMessageID <= 0);
    const [editAlert, setEditAlert] = useState(props.WantToBuyMessageID <= 0);
    const [addToWatchlist, setAddToWatchlist] = useState(props.AddToWatchlist);
    const [textAlertsEnabled, setTextAlertsEnabled] = useState(props.TextAlertsEnabled);
    const routes = useRecoilValue(atoms.routes);
    const currentWebsite = useRecoilValue(atoms.currentWebsite);
    const [siteHasClassifications, setSiteHasClassifications] = useState(props.SelectListItems.TopClassificationOptions && props.SelectListItems.TopClassificationOptions.length > 0);
    const topClassificationIDSelected = props.TopClassificationID || (siteHasClassifications && props.SelectListItems && props.SelectListItems.TopClassificationOptions && props.SelectListItems.TopClassificationOptions.length > 0 ? props.SelectListItems.TopClassificationOptions[0].Value : '');

    const [selectedTopClassificationLabel, setSelectedTopClassificationLabel] = useState(getTopSelectedClassificationLabel(topClassificationIDSelected));
    const [validationErrors, setValidationErrors] = useState(props.validationErrors);
    const [alertData, setAlertData] = useState({
        WantToBuyMessageID: props.WantToBuyMessageID,
        Model: props.Model,
        ModelIsRequired: props.ModelIsRequired,
        CategoryID: props.CategoryID || '',
        TypedManufacturer: props.TypedManufacturer || '',
        EquipmentType: props.EquipmentType,
        YearFrom: props.YearFrom,
        YearTo: props.YearTo,
        PriceLimit: props.FormattedPrice ? UnformatCurrency(props.FormattedPrice, props.CultureCode, props.CurrencyCode, false, true) : '',
        CurrencyCode: props.CurrencyCode,
        LanguageID: '',
        AlertTypeID: props.AlertTypeID,
        PlanningToBuy: props.PlanningToBuy,
        QuantityNeeded: props.QuantityNeeded || 1,
        FitsToCategoryID: props.FitsToCategoryID,
        ShortDescription: props.ShortDescription || '',
        OtherComments: props.OtherComments || '',
        SerialNumber: props.SerialNumber || '',
        PartNumber: props.PartNumber || '',
        CultureCode: props.CultureCode,
        MileageMin: props.MileageMin,
        MileageMax: props.MileageMax,
        HoursMin: props.HoursMin,
        HoursMax: props.HoursMax,
        HorsepowerMin: props.HorsepowerMin,
        HorsepowerMax: props.HorsepowerMax,
        LengthInFeet: props.LengthInFeet,
        LengthInInches: props.LengthInInches,
        WidthInInches: props.WidthInInches,
        showAlertNumberExceededMessage: props.AlertNumberExceeded,
        UserEnteredLocation: props.UserEnteredLocation,
        MaxDistance: props.MaxDistance,
        Engine: props.Engine,
        AddToWatchlist: props.AddToWatchlist,
        CategoryDisplayName: props.CategoryDisplayName,
        AvailableSpecs: props.AvailableSpecs,
        TextAlertsEnabled: props.TextAlertsEnabled,
        EmailAlertsForAuction: props.EmailAlertsForAuction,
        EmailAlertsForSale: props.EmailAlertsForSale,
        TopClassificationID: topClassificationIDSelected,
        TopClassificationCategoryID: props.TopClassificationCategoryID,
        SelectListItems: props.SelectListItems
    });
    const [originalAlertData, setOriginalAlertData] = useState(alertData);
    const [yearOptions, setYearOptions] = useState(props.SelectListItems.YearOptions);
    const [skipExpansionToggle, setSkipExpansionToggle] = useState(checkForExpansionValues);

    const topCatList = [{ Disabled: false, Group: null, Selected: false, Text: 'Equipment', Value: '2' }, { Disabled: false, Group: null, Selected: false, Text: 'Animal', Value: '1' }, { Disabled: false, Group: null, Selected: false, Text: 'Crop', Value: '4' }];
    const [topCatSelected, setTopCatSelected] = useState(topCatList[0]);
    const [categories, setCategories] = useState([]);
    const [originalCategories, setOriginalCategories] = useState([]);
    const [userCurrentLocationButtonClicked, setUserCurrentLocationButtonClicked] = useState(false);
    const [responseProcessed, setResponseProcessed] = useState(false);

    // Necessary for handling autocomplete triggers with correct data.
    const manuRef = useRef();
    const modelRef = useRef();

    useEffect(() => {
        setValidationErrors(props.validationErrors);
    }, [props.validationErrors]);

    useEffect(() => {
        if (userCurrentLocationButtonClicked && props.userEnteredLocation) {
            updateUserLocationField();
            setUserCurrentLocationButtonClicked(false); // Reset the flag after updating
        }
    }, [props.userEnteredLocation]);

    useEffect(() => {
        if (responseProcessed) {
            setOriginalAlertData(alertData);
            setResponseProcessed(false); // Reset the flag
        }
    }, [responseProcessed]);


    const textChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setAlertData(previousState => {
            return { ...previousState, [name]: value == 'All' ? '' : value };
        });
        props.textChange(e);
    };

    const topCatDropdownChange = (e) => {
        let value = e.target.value;
        for (let i = 0; i <= topCatList.length; i++) {
            if (topCatList[i] && topCatList[i].Value && topCatList[i].Value == value) {
                setTopCatSelected(topCatList[i]);
            }
        }

        sandhillsRequest({
            url: routes.CategoryClassification,
            method: 'POST',
            data: {
                categoryId: e.target.value
            },
            errorHandling: {
                message: 'An error occurred while obtaining category classification',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            if (response.TopClassificationOptions) {
                props.SelectListItems.LowerClassificationLabelMappings = response.LowerClassificationLabelMappings;

                setAlertData(previousState => {
                    return {
                        ...previousState,
                        ['SelectListItems']: response,
                        ['TopClassificationID']: value,
                        ['TypedManufacturer']: '',
                        ['Manufacturer']: '',
                        ['Model']: '',
                        ['YearFrom']: '',
                        ['YearTo']: '',
                        ['CategoryDisplayName']: '',
                        ['CategoryID']: ''
                    }
                });

                props.setFormData(previousState => {
                    return {
                        ...previousState,
                        TopClassificationID: value,
                        TypedManufacturer: '',
                        Manufacturer: '',
                        Model: '',
                        CategoryID: '',
                        CategtoryDisplayName: '',
                        HorsepowerMax: '',
                        HorsePowerMin: '',
                        HoursMax: '',
                        HoursMin: '',
                        LengthInFeet: '',
                        LengthInInches: '',
                        MileageMax: '',
                        MileageMin: '',
                        PriceLimit: '',
                        SelectListItems: [],
                        WidthInInches: '',
                        YearFrom: '',
                        YearTo: ''
                    }
                });

                setSiteHasClassifications(true);

            } else {

                setSiteHasClassifications(false);

                setAlertData(previousState => {
                    return {
                        ...previousState,
                        ['TopClassificationID']: '',
                        ['SelectListItems']: response,
                        ['CategoryDisplayName']: '',
                        ['CategoryID']: '',
                        ['TopClassificationCategoryID']: ''
                    }
                })

                props.setFormData(previousState => {
                    return {
                        ...previousState,
                        TopClassificationID: '',
                        TopClassificationCategoryID: '',
                        CategoryDisplayName: '',
                        CategoryID: '',
                        SelectListItems: []
                    }
                });
            }
        });
        
    }
    const debouncedGetCategories = useCallback(
        debounce((manu, model) => {
            getCategories(manu, model)
        }, 500),
        [alertData.TypedManufacturer, alertData.Model]
    );

    /*
     * Grabs the categories based on manu and model inputs,
     * otherwise sets categories to an empty array which triggers
     * the category dropdown to grab all the categories.
     */
    const getCategories = (manu, model) => {
        if (manu && (model || !alertData.ModelIsRequired)) {

            sandhillsRequest({
                url: routes.GetWantToBuyDrilldown,
                data: {
                    manufacturer: manu,
                    model: model
                },
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then((response) => {
                let data = response || [];
                data.push({ Disabled: false, Group: null, Selected: false, Text: 'Show All Categories', Value: 'All' });

                if (data.filter(cat => !cat.IsParent && cat.Name).length == 1) {
                    const manualEvent = {
                        target: {
                            name: "CategoryID",
                            value: data.filter(cat => !cat.IsParent && cat.Name)[0].Value
                        }
                    }
                    categoryDropdownChange(manualEvent);
                }
                

                setCategories(data);
            });
        }
        else {

            setCategories([]);
        }
    }

    const categoryDropdownChange = (e) => {
        /*
         * Necessary logic for ensuring data calls are made correctly and the form data is updated,
         * otherwise the user may be able to submit the form with an unselected category.
         */
        let value = e.target.value == 'All' ? '' : e.target.value;
        if (value == '' && e.target.selectedOptions[0].label == 'Show All Categories') {
            getCategories();
        }
        sandhillsRequest({
            url: routes.GetFullMMMCategoryName,
            method: 'POST',
            data: {
                categoryID: value == '' ? 0 : value
            },
            errorHandling: {
                message: 'An error occurred while obtaining category display name',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            setAlertData(previousState => {
                return { ...previousState, ['CategoryDisplayName']: response, ['CategoryID']: value };
            })
            props.fieldChange('CategoryDisplayName', response);
        });

        if (!siteHasClassifications) {
            let data = { 'categoryId': value == '' ? 0 : value, 'specNames': listingAlertSpecNamesToCheck.validSpecNames, 'includeTrailerSpecs': false, "categoryContext": props.CategoryContextOverride };
            sandhillsRequest({
                url: routes.CategorySpecCheck,
                method: 'POST',
                data: data,
                errorHandling: {
                    message: 'An error occurred while obtaining specs',
                    showDetails: true,
                    useConsole: true,
                    useAlert: false
                }
            }).then((response) => {
                setAlertData(previousState => {
                    return { ...previousState, ['AvailableSpecs']: response };
                })
            });
        }
        let modelRequired = alertData.ModelIsRequired;
        if (props.ModelNotRequiredCats && props.ModelNotRequiredCats.length > 0) {
            let selectedCats = props.ModelNotRequiredCats.filter(cat => cat === value || value === '');
            modelRequired = selectedCats.length < 1;
        }
        setAlertData(previousState => {
            return {
                ...previousState,
                ModelIsRequired: modelRequired,
                CategoryID: value
            }
        });
        props.setFormData(previousState => {
            return {
                ...previousState,
                ModelIsRequired: modelRequired,
                CategoryID: value
            }
        });

        textChange(e);
    }
    const handleCurrencyChange = (e) => {
        let newCurrencyCode = e.target.options[e.target.selectedIndex].text;
        let newCultureCode = e.target.value.substring(4);

        setAlertData(previousState => {
            return {
                ...previousState,
                CurrencyCode: newCurrencyCode,
                CultureCode: newCultureCode
            };
        });
        props.handleCurrencyChange(e);
    }
    const handleManuAutocomplete = (e) => {
        setAlertData(previousState => {
            return {
                ...previousState,
                TypedManufacturer: e
            };
        });
        props.fieldChange('TypedManufacturer', e);
    }
    const handleModelAutocomplete = (e) => {
        setAlertData(previousState => {
            return {
                ...previousState,
                Model: e
            };
        });
        props.fieldChange('Model', e);
    }
    const handleChangeForSale = (e) => {
        props.fieldChange('EmailAlertsForSale', !alertData.EmailAlertsForSale);
        setAlertData(previousState => {
            return {
                ...previousState,
                EmailAlertsForSale: !previousState.EmailAlertsForSale
            }
        });
    };
    const handleChangeForAuction = (e) => {
        props.fieldChange('EmailAlertsForAuction', !alertData.EmailAlertsForAuction);
        setAlertData(previousState => {
            return {
                ...previousState,
                EmailAlertsForAuction: !previousState.EmailAlertsForAuction
            }
        });
    };

    const toggleWatchlist = (obj) => {
        setAddToWatchlist(!addToWatchlist);
        if (props.WantToBuyMessageID) {
            props.toggleWatchlist(obj, !addToWatchlist);
        }
        props.fieldChange('AddToWatchlist', !addToWatchlist);
        setAlertData(previousState => {
            return {
                ...previousState,
                AddToWatchlist: !addToWatchlist
            };
        });
    };
    const toggleTextAlerts = (obj) => {
        setTextAlertsEnabled(!textAlertsEnabled);
        if (props.WantToBuyMessageID) {
            props.toggleTextAlert(obj || props, !textAlertsEnabled);
        }
        props.fieldChange('TextAlertsEnabled', !textAlertsEnabled);
        setAlertData(previousState => {
            return {
                ...previousState,
                TextAlertsEnabled: !textAlertsEnabled
            };
        });
    };

    const handleUserCurrentLocationClick = (e) => {
        props.enterUsersCurrentLocation(e);
        setUserCurrentLocationButtonClicked(true); // Prevents the useEffect from updating location field unexpectedly.
    }

    const updateUserLocationField = () => {
        if (props.userEnteredLocation) {
            setAlertData(previousState => ({
                ...previousState,
                UserEnteredLocation: props.userEnteredLocation
            }));
        }
    };

    const handleLocationFieldChange = (e) => {
        setAlertData(previousState => {
            return {
                ...previousState,
                UserEnteredLocation: e.target.value
            };
        });

        props.handleLocationFieldChange(e);
    }
    const getAutoCompleteCallback = () => {
        const callback = props.getAutoCompleteCallback();
        return (e, ui) => {
            setAlertData(previousState => {
                return {
                    ...previousState,
                    UserEnteredLocation: ui.item.value
                };
            });
            callback(e, ui);
        }
    };

    const toggleDisplay = () => {
        setDisplayExpansion(!displayExpansion);
    }

    const toggleEdit = (e) => {
        if (editAlert || !props.editMode) {
            if (alertData.TopClassificationID) {
                sandhillsRequest({
                    url: routes.CategoryClassification,
                    method: 'POST',
                    data: {
                        categoryId: alertData.TopClassificationID
                    },
                    errorHandling: {
                        message: 'An error occurred while obtaining category classification',
                        showDetails: true,
                        useConsole: true,
                        useAlert: false
                    }
                }).then((response) => {
                    setAlertData(previousState => {
                        return {
                            ...previousState,
                            SelectListItems: response,
                            AvailableSpecs: [],
                            TypedManufacturer: '',
                            Manufacturer: '',
                            Model: ''
                        }
                    });
                    props.SelectListItems.LowerClassificationLabelMappings = response.LowerClassificationLabelMappings;


                    setSiteHasClassifications(true);
                    setResponseProcessed(true);
                });
            } else {
                props.SelectListItems.LowerClassificationLabelMappings = null;

                //Need to set everything back to equipment
                setTopCatSelected(topCatList[0]);
                setSiteHasClassifications(false);
                setOriginalAlertData(alertData);
                setOriginalCategories(categories);
            }

            setDisplayExpansion(true);
            if (editAlert) {
                let errors = props.runValidation();
                if (Object.keys(errors).length <= 0) {
                    setEditAlert(false);
                    props.editLock(false);

                    props.setEmailAlerts(previousState => {
                        let alerts = [...previousState];
                        alerts[props.id] = alertData;

                        return alerts;
                    });

                    props.submitForm(e, props.reloadPage);
                    setValidationErrors([]);
                    setSkipExpansionToggle(checkForExpansionValues());
                } else {
                    setValidationErrors(errors);
                }
            } else {
                props.editLock(true);
                setEditAlert(true);
                props.setFormData(alertData);
            }
        }
    };

    const onKeyPress = (e) => {
        if (e.code === 'Enter') {
            props.handleLocationFieldChange(e);
        }
    };

    const onDelete = () => {
        if (editAlert) {
            setEditAlert(false);
            setDisplayExpansion(false);
            props.editLock(false);
            setAlertData(originalAlertData);
            setCategories(originalCategories);
            if (props.WantToBuyMessageID <= 0) {
                props.setShowNewForm(false);
            }
        } else {
            props.deleteAlert(props.WantToBuyMessageID);
        }
    }

    const locationFields = () => {
        return (
            editAlert ?
                <>
                    <div className='display-row'>
                        <div className='display-content-label'>Location:</div>
                        <div className='display-content-value mobile-location-stretch' style={{ border: 'none' }}>
                            <TextField
                                name='UserEnteredLocation'
                                value={alertData.UserEnteredLocation}
                                class='wtb-location-search'
                                type='search'
                                id='UserEnteredLocation'
                                label={translator.translate('sandhills.citystatezip')}
                                required={false}
                                updateField={handleLocationFieldChange}
                                onFieldChanged={handleLocationFieldChange}
                                onChange={handleLocationFieldChange}
                                focus={false}
                                placeholder={translator.translate('sandhills.citystatezip')}
                                autoComplete={{
                                    ajaxUrl: (e) => props.getAutoCompleteLocationUrl(e),
                                    callback: getAutoCompleteCallback()
                                }}
                                autoCompleteDelay='1'
                                autoSuggestWidth={330}
                                onKeyPress={onKeyPress}
                                validationErrors={validationErrors.UserEnteredLocation}
                                hideLabel={true}
                            />
                            <button title={translator.translate('sandhills.usemycurrentlocation')} className='current-loc-btn ts-button' onClick={handleUserCurrentLocationClick}>
                                <i className='fas fa-crosshairs' aria-hidden='true'></i>
                            </button>
                            {props.locationErrorMessage &&
                                <div className='error'>{props.locationErrorMessage}</div>
                            }
                        </div>
                    </div>
                    <div className='display-row'>
                        <div className='display-content-label'>{translator.translate('Sandhills.MaxDistanceMiles')}</div>
                        <div className='display-content-value mobile-location-stretch' style={{ border: 'none' }}>
                            <SelectField
                                id='MaxDistance'
                                name='mileageUnit'
                                label={translator.translate('Sandhills.MaxDistanceMiles')}
                                value={alertData.MaxDistance}
                                options={alertData.SelectListItems.DistanceLimitationOptions}
                                required={false}
                                validationErrors={validationErrors.mileageUnit}
                                onFieldChanged={(e) => setAlertData(previousState => {
                                    return { ...previousState, MaxDistance: e.target.value };
                                },
                                    props.setFormData(previousState => {
                                        return { ...previousState, MaxDistance: e.target.value };
                                    })
                                )}
                                hideLabel={true}
                            />
                        </div>
                    </div>
                </>
                :
                <>
                    {alertData.UserEnteredLocation &&
                        <>
                            <div className='display-row'>
                                <div className='display-content-label'>Location:</div>
                                <div className='display-content-value'>{alertData.UserEnteredLocation}</div>
                            </div>
                            <div className='display-row'>
                                <div className='display-content-label'>Distance From Location (Miles):</div>
                                <div className='display-content-value'>{alertData.MaxDistance}</div>
                            </div>
                        </>
                    }
                </>

        );
    }

    const iconButtons = () => {
        return (
            <div className='email-alerts__alert-buttons alert-main-display buffer'>
                {!editAlert && skipExpansionToggle ?
                    <div tabIndex='0' className='icon-buttons' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleDisplay(); } }} onClick={toggleDisplay} role='button' title={translator.translate('sandhills.viewmore')}><i className={displayExpansion ? 'fas fa-minus' : 'fas fa-plus'} /></div>
                    :
                    <></>
                }
                {props.editMode && !editAlert ?
                    <></>
                    :
                    <div tabIndex='0' className={editAlert ? 'icon-buttons save' : skipExpansionToggle ? 'icon-buttons' : 'icon-buttons half-width'} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleEdit(); } }}  onClick={toggleEdit} role='button' title={editAlert ? translator.translate('sandhills.photosvideos.savechanges') : translator.translate('sandhills.edit')}><i className={editAlert ? 'fas fa-save' : 'fas fa-pencil'} /></div>
                }
                {props.editMode && !editAlert ?
                    <></>
                    :
                    <div tabIndex='0' className={editAlert ? 'icon-buttons half-width' : skipExpansionToggle ? 'icon-buttons' : 'icon-buttons half-width'} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onDelete(); } }} onClick={onDelete} role='button' title={editAlert ? translator.translate('sandhills.closepage') : translator.translate('sandhills.tradesites.mvc.deletealert')}><i className={editAlert ? 'fas fa-x' : 'fas fa-trash'} /></div>}
            </div>
        );
    }

    //jsx for livestock/hay+straw categories
    const classificationBasedFields = () => {
        return (
            <>
                {editAlert ?
                    <>
                        <SelectField
                            options={(currentWebsite?.Site?.IsBidcaller || currentWebsite?.Site?.IsAuctionTime) ? topCatList : alertData.SelectListItems.TopClassificationOptions}
                            class={windowSize.isMobile ? 'alert-main-display' : 'alert-main-display seventy-width buffer'}
                            name='TopClassificationID'
                            required={!alertData.TopClassificationID}
                            value={alertData.TopClassificationID}
                            validationErrors={validationErrors.TopClassificationID}
                            label={translator.translate('sandhills.category')}
                            hideLabel={true}
                            id='TopClassificationID'
                            onFieldChanged={(e) => {
                                topCatDropdownChange(e);
                                let value = e.target.value;
                                setSelectedTopClassificationLabel(getTopSelectedClassificationLabel(parseInt(value)));

                                setAlertData(previousState => {
                                    return {
                                        ...previousState,
                                        TopClassificationID: value,
                                        TopClassificationCategoryID: '',
                                        CategoryID: ''
                                    }
                                });
                                props.setFormData(previousState => {
                                    return {
                                        ...previousState,
                                        TopClassificationID: value,
                                        TopClassificationCategoryID: '',
                                        CategoryID: ''
                                    }
                                });
                            }}
                        />
                        {windowSize.isMobile &&
                            <>
                                <SelectField
                                    id='TopClassificationCategoryID'
                                    name='TopClassificationCategoryID'
                                    value={alertData.TopClassificationCategoryID}
                                    label={translator.translate('sandhills.category')}
                                    options={alertData.SelectListItems.TopClassificationCategoryOptions[alertData.TopClassificationID]}
                                    class='alert-main-display'
                                    required={!alertData.TopClassificationCategoryID}
                                    validationErrors={validationErrors.TopClassificationID}
                                    onFieldChanged={categoryDropdownChange}
                                    hideLabel={true}
                                    validationErrors={validationErrors.TopClassificationCategoryID}
                                    onFieldChanged={(e) => {
                                        let value = e.target.value;
                                        setAlertData(previousState => {
                                            return {
                                                ...previousState,
                                                TopClassificationCategoryID: value
                                            }
                                        });
                                        props.setFormData(previousState => {
                                            return {
                                                ...previousState,
                                                TopClassificationCategoryID: value
                                            }
                                        });
                                    }}
                                />
                            {alertData.TopClassificationCategoryID && !topLevelClassificationsToSkipLowerClassifications.includes(Number(alertData.TopClassificationCategoryID)) &&
                                    <SelectField
                                        id='CategoryID'
                                        name='CategoryID'
                                        value={alertData.CategoryID}
                                        label={translator.translate('sandhills.category')}
                                        options={alertData.SelectListItems.LowerClassificationCategoryOptions[alertData.TopClassificationCategoryID]}
                                        class='alert-main-display'
                                        required={true}
                                        validationErrors={validationErrors.CategoryID}
                                        onFieldChanged={categoryDropdownChange}
                                        hideLabel={true}
                                    />}
                            </>
                        }
                    </>
                    :
                    <>
                        <div className='alert-main-display'>{alertData.CategoryDisplayName}</div>
                        <div className='alert-main-display'>{alertData.TypedManufacturer}</div>
                        <div className='alert-main-display'>{alertData.Model}</div>
                    </>
                }
                <div className={windowSize.isMobile ? 'alert-main-display' : 'alert-main-display buffer'}>
                    <Toggle
                        classNames='watchlist-toggle'
                        id={props.WantToBuyMessageID + '-watchlist'}
                        IsChecked={addToWatchlist}
                        onChange={toggleWatchlist}
                        emailAlert={props}
                        label={translator.translate('sandhills.tradepubwebsite.mvc.addtowatchlist')}
                        hideLabel={!windowSize.isMobile}
                    /></div>
                <div className='alert-main-display'>
                    {props.TextAlertFeatureEnabled &&
                    {
                        ...props.alertsEnabled ?
                            <Toggle
                                classNames='text-alert-toggle buffer'
                                id={props.WantToBuyMessageID + '-text-alert'}
                                IsChecked={alertData.TextAlertsEnabled}
                                onChange={(e) => { toggleTextAlerts() }}
                                label={translator.translate('sandhills.textalerts')}
                                emailAlert={props}
                                hideLabel={!windowSize.isMobile}
                            />
                            :
                            <>
                                <a role='button' tabIndex='0' onClick={(e) => { props.showTextAlertModal(); toggleTextAlerts(); }}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.showTextAlertModal(); } }}>Sign Up</a>
                            </>
                    }
                    }
                </div>
                {!windowSize.isMobile && <>{iconButtons()}</>}
                
                {editAlert && !windowSize.isMobile &&
                    <div className="display-row">
                        <SelectField
                            id='TopClassificationCategoryID'
                            name='TopClassificationCategoryID'
                            label={translator.translate('sandhills.category')}
                            value={alertData.TopClassificationCategoryID}
                            options={alertData.SelectListItems.TopClassificationCategoryOptions[alertData.TopClassificationID]}
                            class='half-width buffer'
                            required={!alertData.TopClassificationCategoryID}
                            validationErrors={validationErrors.TopClassificationID}
                            onFieldChanged={categoryDropdownChange}
                            hideLabel={true}
                            validationErrors={validationErrors.TopClassificationCategoryID}
                            onFieldChanged={(e) => {
                                let value = e.target.value;
                                setAlertData(previousState => {
                                    return {
                                        ...previousState,
                                        TopClassificationCategoryID: value
                                    }
                                });
                                props.setFormData(previousState => {
                                    return {
                                        ...previousState,
                                        TopClassificationCategoryID: value
                                    }
                                });
                            }}
                        />
                        {alertData.TopClassificationCategoryID && !topLevelClassificationsToSkipLowerClassifications.includes(Number(alertData.TopClassificationCategoryID)) &&
                            <SelectField
                                id='CategoryID'
                                name='CategoryID'
                                label={translator.translate('sandhills.category')}
                                value={alertData.CategoryID}
                                options={alertData.SelectListItems.LowerClassificationCategoryOptions[alertData.TopClassificationCategoryID]}
                                class='half-width buffer'
                                required={true}
                                validationErrors={validationErrors.CategoryID}
                                onFieldChanged={categoryDropdownChange}
                                hideLabel={true}
                            />}
                    </div>}
                {displayExpansion &&
                    props.allowDistanceLimitation ?
                    <>{locationFields()}</>
                    : ''
                }
                {windowSize.isMobile && <>{iconButtons()}</>}
            </>
        );
    };

    //jsx for equipment categories
    const nonClassificationFields = () => {
        return (
            <>
                
                {editAlert ?
                    <>
                        {(currentWebsite?.Site?.IsBidcaller || currentWebsite?.Site?.IsAuctionTime) &&
                            <>
                                <SelectField
                                    id='TopCatList'
                                    label={translator.translate('sandhills.category')}
                                    options={topCatList}
                                    class={windowSize.isMobile ? 'alert-main-display' : 'alert-main-display seventy-width buffer'}
                                    name='TopCatList'
                                    value={topCatSelected.Value}
                                    id='topCat'
                                    onFieldChanged={(e) => {
                                        topCatDropdownChange(e);

                                    }}
                                    hideLabel={true}
                                />
                                <br></br>
                            </>
                        }
                        <TextField
                            id='TypedManufacturer'
                            name='TypedManufacturer'
                            value={alertData.TypedManufacturer}
                            ref={manuRef}
                            type='text'
                            label={translator.translate('sandhills.manufacturer')}
                            required={!alertData.TypedManufacturer}
                            validationErrors={validationErrors.TypedManufacturer}
                            updateField={handleManuAutocomplete}
                            showRequired={true}
                            class='alert-main-display full-width'
                            onFieldChanged={textChange}
                            onFieldBlur={(e) => { debouncedGetCategories(alertData.TypedManufacturer, alertData.Model) }}
                            onChange={textChange}
                            placeholder={translator.translate('sandhills.entermanufacturer')}
                            autoComplete={{
                                ajaxUrl: (e) => props.getAutoCompleteUrl(e, routes.GetManuAutoComplete),
                                postData: (e) => props.getAutoCompleteManuData(e)
                            }}
                            isWTBInput={true}
                            hideLabel={!windowSize.isMobile}
                        />
                        {windowSize.isMobile &&
                            <>
                                <TextField
                                id='Model'
                                name='Model'
                                value={alertData.Model}
                                ref={modelRef}
                                type='text'
                                class='alert-main-display'
                                placeholder={translator.translate('sandhills.entermodel')}
                                required={alertData.ModelIsRequired && !alertData.Model}
                                label={translator.translate('sandhills.model')}
                                showRequired={true}
                                validationErrors={validationErrors.Model}
                                onFieldBlur={(e) => { debouncedGetCategories(alertData.TypedManufacturer, alertData.Model) }}
                                onChange={textChange}
                                onFieldChanged={textChange}
                                autoComplete={{
                                    ajaxUrl: (e) => props.getAutoCompleteUrl(e, routes.GetModelAutoComplete),
                                    postData: (e) => props.getAutoCompleteModelData(e)
                                }}
                                updateField={handleModelAutocomplete}
                                isWTBInput={true}
                                hideLabel={!windowSize.isMobile}
                                />
                            <SelectField
                                    id='CategoryID'
                                    name='CategoryID'
                                    value={alertData.CategoryID}
                                    options={categories.length > 0 ? categories : alertData.SelectListItems.CategoryOptions}
                                    class='alert-main-display'
                                    label={translator.translate('sandhills.category')}
                                    required={!alertData.CategoryID}
                                    showRequired={true}
                                    validationErrors={validationErrors.CategoryID}
                                    onFieldChanged={categoryDropdownChange}
                                    hideLabel={!windowSize.isMobile}
                                />
                            </>
                        }
                    </>
                    :
                    <>
                        <div className='cat-mm-td alert-main-display'>
                            {windowSize.isMobile &&
                                <div className='mobile-alert-label'>{translator.translate('sandhills.category')}</div>
                            }
                            <div className='mobile-alert-value'>{truncateString(alertData.CategoryDisplayName, maxLength * 2)}</div>
                        </div>
                        <div className='alert-main-display'>
                            {windowSize.isMobile &&
                                <div className='mobile-alert-label'>{translator.translate('sandhills.manufacturer')}</div>
                            }
                            <div className='mobile-alert-value'>{truncateString(alertData.TypedManufacturer, maxLength)}</div>
                        </div>
                        <div className='alert-main-display'>
                            {windowSize.isMobile &&
                                <div className='mobile-alert-label'>{translator.translate('sandhills.model')}</div>
                            }
                            <div className='mobile-alert-value'>{truncateString(alertData.Model, maxLength)}</div>
                        </div>
                    </>
                }
                <div className='alert-main-display'>
                    <Toggle
                        classNames={alertData.CategoryID ? 'watchlist-toggle' : 'watchlist-toggle buffer'}
                        label={translator.translate('sandhills.tradepubwebsite.mvc.addtowatchlist')}
                        id={props.WantToBuyMessageID + '-watchlist'}
                        IsChecked={addToWatchlist}
                        onChange={toggleWatchlist}
                        emailAlert={props}
                        hideLabel={!windowSize.isMobile}
                    /></div>
                <div className='alert-main-display'>
                    {props.TextAlertFeatureEnabled &&
                    {
                        ...props.alertsEnabled ?
                            <Toggle
                                classNames={alertData.CategoryID ? 'text-alert-toggle' : 'text-alert-toggle buffer'}
                                id={props.WantToBuyMessageID + '-text-alert'}
                                IsChecked={alertData.TextAlertsEnabled}
                                onChange={(e) => { toggleTextAlerts() }}
                                label={translator.translate('sandhills.textalerts')}
                                emailAlert={props}
                                hideLabel={!windowSize.isMobile}
                            />
                            :
                            <>
                                {windowSize.isMobile &&
                                    <div className='mobile-alert-label'>{translator.translate('sandhills.textalerts')}</div>
                                }
                                <a role='button' tabIndex='0' onClick={(e) => { props.showTextAlertModal(); toggleTextAlerts(); }}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.showTextAlertModal(); } }}>Sign Up</a>
                            </>
                    }
                    }
                </div>
                {!windowSize.isMobile && <>{iconButtons()}</>}
                {displayExpansion && !siteHasClassifications && editAlert && !windowSize.isMobile ?
                    <div className='email-alerts__alert-expanded-info'>
                        <div className='display-row flex'>
                            <div className='half-width'>
                                <TextField
                                    id='Model'
                                    name='Model'
                                    value={alertData.Model}
                                    ref={modelRef}
                                    type='text'
                                    label={translator.translate('sandhills.model')}
                                    placeholder={translator.translate('sandhills.entermodel')}
                                    required={alertData.ModelIsRequired && !alertData.Model}
                                    showRequired={true}
                                    class={alertData.TypedManufacturer ? '' : 'buffer'}
                                    validationErrors={validationErrors.Model}
                                    onFieldBlur={(e) => { debouncedGetCategories(alertData.TypedManufacturer, alertData.Model) }}
                                    onChange={textChange}
                                    onFieldChanged={textChange}
                                    autoComplete={{
                                        ajaxUrl: (e) => props.getAutoCompleteUrl(e, routes.GetModelAutoComplete),
                                        postData: (e) => props.getAutoCompleteModelData(e)
                                    }}
                                    updateField={handleModelAutocomplete}
                                    isWTBInput={true}
                                    hideLabel={!windowSize.isMobile}
                                />
                            </div>
                            <div className='half-width'>
                                <SelectField
                                    id='CategoryID'
                                    name='CategoryID'
                                    value={alertData.CategoryID}
                                    options={categories.length > 0 ? categories : alertData.SelectListItems.CategoryOptions}
                                    class={''}
                                    label={translator.translate('sandhills.category')}
                                    required={!alertData.CategoryID}
                                    showRequired={true}
                                    validationErrors={validationErrors.CategoryID}
                                    onFieldChanged={categoryDropdownChange}
                                    hideLabel={!windowSize.isMobile}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    <></>
                }

                {displayExpansion && !siteHasClassifications &&
                    <div className='email-alerts__alert-expanded-info'>
                        {editAlert ?
                            <>
                                <div className='display-row'>
                                    <div className='display-content-label'><TranslationText tKey='sandhills.tradepubwebsite.mvc.yearrange' />:</div>
                                    {yearOptions &&
                                        <SelectField
                                            id='YearFrom'
                                            name='YearFrom'
                                            label={translator.translate('sandhills.yearfrom')}
                                            value={alertData.YearFrom}
                                            options={yearOptions}
                                            class='wtb-input-half'
                                            required={false}
                                            validationErrors={validationErrors.YearFrom}
                                            onFieldChanged={textChange}
                                            hideLabel={true}
                                        />}
                                    {yearOptions &&
                                        <SelectField
                                            id='YearTo'
                                            name='YearTo'
                                            label={translator.translate('sandhills.yearto')}
                                            value={alertData.YearTo}
                                            options={yearOptions}
                                            class='wtb-input-half'
                                            required={false}
                                            validationErrors={validationErrors.YearTo}
                                            onFieldChanged={textChange}
                                            hideLabel={true}
                                        />}
                                </div>
                            </>
                            :
                            <>
                                {(alertData?.YearFrom > 0 || alertData?.YearTo > 0) &&
                                    <div className='display-row'>
                                        <div className='display-content-label'><TranslationText tKey='sandhills.tradepubwebsite.mvc.yearrange' />:</div>
                                        <div className='display-content-value'>{alertData.YearFrom > 0 && alertData.YearFrom} - {alertData.YearTo > 0 && alertData.YearTo}</div>
                                    </div>}
                            </>
                        }

                        {alertData?.AvailableSpecs?.some((o) => o == listingAlertSpecNamesToCheck.hours) ?
                            editAlert ?
                                <>
                                    <span>
                                        <div className='display-row'>
                                            <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.hoursrange' />:</div>
                                            <div className='wtb-input-half'>
                                                <TextField
                                                    id='HoursMin'
                                                    name='HoursMin'
                                                    value={alertData.HoursMin}
                                                    label={translator.translate('sandhills.hoursfrom')}
                                                    placeholder={translator.translate('sandhills.hoursfrom')}
                                                    type='text'
                                                    required={false}
                                                    validationErrors={validationErrors.HoursMin}
                                                    onFieldChanged={textChange}
                                                    hideLabel={true}
                                                />
                                            </div>
                                            <div className='wtb-input-half'>
                                                <TextField
                                                    id='HoursMax'
                                                    name='HoursMax'
                                                    value={alertData.HoursMax}
                                                    type='text'
                                                    label={translator.translate('sandhills.hoursto')}
                                                    placeholder={translator.translate('sandhills.hoursto')}
                                                    required={false}
                                                    validationErrors={validationErrors.HoursMax}
                                                    onFieldChanged={textChange}
                                                    hideLabel={true}
                                                />
                                            </div>
                                        </div>
                                    </span></>
                                :
                                <>
                                    {(alertData.HoursMin || alertData.HoursMax) &&
                                        <div className='display-row'>
                                            <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.hoursrange' />:</div>
                                            <div className='display-content-value'>{alertData.HoursMin} - {alertData.HoursMax}</div>
                                        </div>
                                    }
                                </> : <></>}
                        {alertData?.AvailableSpecs?.some((o) => listingAlertSpecNamesToCheck.mileage.includes(o)) ?
                            editAlert ?
                                <>
                                    <div className='display-row'>
                                        <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.mileagerange' />:</div>
                                        <div className='wtb-input-half'>
                                            <TextField
                                                id='MileageMin'
                                                name='MileageMin'
                                                value={alertData.MileageMin}
                                                type='text'
                                                required={false}
                                                label={translator.translate('sandhills.mileagefrom')}
                                                placeholder={translator.translate('sandhills.mileagefrom')}
                                                validationErrors={validationErrors.MileageMin}
                                                onFieldChanged={textChange}
                                                hideLabel={true}
                                            />
                                        </div>
                                        <div className='wtb-input-half'>
                                            <TextField
                                                id='MileageMax'
                                                name='MileageMax'
                                                value={alertData.MileageMax}
                                                type='text'
                                                label={translator.translate('sandhills.mileageto')}
                                                placeholder={translator.translate('sandhills.mileageto')}
                                                class='wtb-mileage-to'
                                                required={false}
                                                validationErrors={validationErrors.MileageMax}
                                                onFieldChanged={textChange}
                                                hideLabel={true}
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    {(alertData.MileageMin || alertData.MileageMax) &&
                                        <div className='display-row'>
                                            <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.mileagerange' />:</div>
                                            <div className='display-content-value'>{alertData.MileageMin} - {alertData.MileageMax}</div>
                                        </div>
                                    }
                                </> : <></>}
                        {alertData?.AvailableSpecs?.some((o) => o == listingAlertSpecNamesToCheck.horsepower) ?
                            editAlert ?
                                <>
                                    <div className='display-row'>
                                        <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.horsepowerrange' />:</div>
                                        <div className='wtb-input-half'>
                                            <TextField
                                                id='HorsepowerMin'
                                                name='HorsepowerMin'
                                                value={alertData.HorsepowerMin}
                                                type='text'
                                                label={translator.translate('sandhills.horsepowerfrom')}
                                                placeholder={translator.translate('sandhills.horsepowerfrom')}
                                                required={false}
                                                validationErrors={validationErrors.HorsepowerMin}
                                                onFieldChanged={textChange}
                                                hideLabel={true}
                                            />
                                        </div>
                                        <div className='wtb-input-half '>
                                            <TextField
                                                id='HorsepowerMax'
                                                name='HorsepowerMax'
                                                value={alertData.HorsepowerMax}
                                                label={translator.translate('sandhills.horsepowerto')}
                                                placeholder={translator.translate('sandhills.horsepowerto')}
                                                type='text'
                                                required={false}
                                                validationErrors={validationErrors.HorsepowerMax}
                                                onFieldChanged={textChange}
                                                hideLabel={true}
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    {(alertData.HorsepowerMin || alertData.HorsepowerMax) &&
                                        <div className='display-row'>
                                            <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.horsepowerrange' />:</div>
                                            <div className='display-content-value'>{alertData.HorsepowerMin !== 0 ? alertData.HorsepowerMin : ''} - {alertData.HorsepowerMax !== 0 ? alertData.HorsepowerMax : ''}</div>
                                        </div>
                                    }
                                </> : <></>}
                        {alertData?.AvailableSpecs?.some((o) => o == listingAlertSpecNamesToCheck.length) ?
                            editAlert ?
                                <>
                                    <div className='display-row'>
                                        <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.length' />:</div>
                                        <div className='wtb-input-half '>
                                            <TextField
                                                id='LengthInFeet'
                                                name='LengthInFeet'
                                                value={alertData.LengthInFeet}
                                                type='text'
                                                required={false}
                                                label={translator.translate('sandhills.lengthfrom')}
                                                placeholder={translator.translate('sandhills.lengthfrom')}
                                                validationErrors={validationErrors.LengthInFeet}
                                                onFieldChanged={textChange}
                                                placeholder='ft'
                                                hideLabel={true}
                                            />
                                        </div>
                                        <div className='wtb-input-half '>
                                            <TextField
                                                id='LengthInInches'
                                                name='LengthInInches'
                                                value={alertData.LengthInInches}
                                                type='text'
                                                required={false}
                                                label={translator.translate('sandhills.lengthto')}
                                                placeholder={translator.translate('sandhills.lengthto')}
                                                validationErrors={validationErrors.LengthInInches}
                                                onFieldChanged={textChange}
                                                placeholder='in'
                                                hideLabel={true}
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    {(alertData.LengthInFeet || alertData.LengthInInches) &&
                                        <>
                                            <div className='display-row'>
                                                <div className='display-content-label'><TranslationText tKey='sandhills.tradepubwebsite.mvc.length' />:</div>
                                                <div className='display-content-value'>{alertData.LengthInFeet}</div>
                                            </div>
                                            <div className='display-row'>
                                                <div className='display-content-label'><TranslationText tKey='sandhills.tradesites.mvc.lengthinches' />:</div>
                                                <div className='display-content-value'>{alertData.LengthInInches}</div>
                                            </div>
                                        </>
                                    }
                                </> : <></>}
                        {alertData?.AvailableSpecs?.some((o) => o == listingAlertSpecNamesToCheck.width) ?
                            editAlert ?
                                <>
                                    <div className='display-row'>
                                        <div className='display-content-label'><TranslationText tKey='sandhills.crm.dscrm.widthinches' />:</div>
                                        <div className='wtb-input-half '>
                                            <TextField
                                                id='WidthInInches'
                                                name='WidthInInches'
                                                value={alertData.WidthInInches}
                                                label={translator.translate('sandhills.widthfrom')}
                                                placeholder={translator.translate('sandhills.width')}
                                                type='text'
                                                required={false}
                                                validationErrors={validationErrors.WidthInInches}
                                                onFieldChanged={textChange}
                                                hideLabel={true}
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    {alertData.WidthInInches &&
                                        <div className='display-row'>
                                            <div className='display-content-label'><TranslationText tKey='sandhills.crm.dscrm.widthinches' />:</div>
                                            <div className='display-content-value'>{alertData.WidthInInches}</div>
                                        </div>
                                    }
                                </> : <></>}
                        {alertData?.AvailableSpecs?.some((o) => o == listingAlertSpecNamesToCheck.engine) ?
                            editAlert ?
                                <>
                                    <div className='display-row'>
                                        <div className='display-content-label'><TranslationText tKey='sandhills.enginemanufacturer' />:</div>
                                        <div className='display-content-value' style={{ border: 'none' }}>
                                            <TextField
                                                id='Engine'
                                                name='Engine'
                                                value={alertData.Engine}
                                                label={translator.translate('sandhills.engine')}
                                                placeholder={translator.translate('sandhills.engine')}
                                                type='text'
                                                required={false}
                                                validationErrors={validationErrors.Engine}
                                                onFieldChanged={textChange}
                                                hideLabel={true}
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    {alertData.Engine &&
                                        <div className='display-row'>
                                            <div className='display-content-label'><TranslationText tKey='sandhills.enginemanufacturer' />:</div>
                                            <div className='display-content-value'>{alertData.Engine}</div>
                                        </div>
                                    }
                                </> : <></>}
                        {editAlert ?
                            <div className='display-row'>
                                <div className='display-content-label'><TranslationText tKey='sandhills.pricelimit' />:</div>
                                <div className='wtb-input-half'>
                                    <TextField
                                        id='PriceLimit'
                                        name='PriceLimit'
                                        value={UnformatCurrency(alertData.PriceLimit, alertData.CultureCode, alertData.CurrencyCode)}
                                        type='text'
                                        placeholder={translator.translate('sandhills.maxprice')}
                                        validationErrors={validationErrors.PriceLimit}
                                        onFieldChanged={textChange}
                                        onBlurHandler={(e) => { textChange(e) }}
                                        label={translator.translate('sandhills.maxprice')}
                                        hideLabel={true}
                                    />
                                </div>
                                <div className='wtb-input-half'>
                                    <label className='visually-hidden' htmlFor='CurrencyCode'>{translator.translate('sandhills.tradepubwebsite.mvc.currency')}</label>
                                    <select id='CurrencyCode' onChange={handleCurrencyChange} name='CurrencyCode' value={alertData.CurrencyCode + ' ' + alertData.CultureCode}>
                                        {alertData.SelectListItems.CurrencyCodeOptions.map((item, index) =>
                                            <option key={index} value={item.Text + ' ' + item.Value}>{item.Text}</option>)}
                                    </select>
                                    <span className='red'>{validationErrors.CurrencyCode}</span>
                                </div>
                            </div>
                            :
                            <>
                                {alertData.PriceLimit &&
                                    <div className='display-row'>
                                        <div className='display-content-label'><TranslationText tKey='sandhills.pricelimit' />:</div>
                                        <div className='display-content-value'>{alertData.PriceLimit} {alertData.CurrencyCode}</div>
                                    </div>}
                            </>
                        }
                        {props.allowDistanceLimitation ?
                            locationFields()
                            : <></>}
                        {(!currentWebsite?.Site?.IsBidcaller || !currentWebsite?.Site?.IsAuctionTime) &&
                            <div className='display-row'>
                                <div className='display-content-label'>Listing Market Type</div>
                                <div className='wtb-input-half toggle-inline mobile-location-stretch'>
                                    {editAlert ?
                                        <>
                                            <Toggle
                                                id='retail-toggle'
                                                classNames='watchlist-toggle'
                                                IsChecked={alertData.EmailAlertsForSale}
                                                onChange={handleChangeForSale}
                                                emailAlert={props}
                                                isLabelWrapped={true}
                                                label={translator.translate('sandhills.tradepubwebsite.mvc.retail')}
                                            />
                                            <Toggle
                                                id='auction-toggle'
                                                classNames='watchlist-toggle'
                                                IsChecked={alertData.EmailAlertsForAuction}
                                                onChange={handleChangeForAuction}
                                                emailAlert={props}
                                                isLabelWrapped={true}
                                                label={translator.translate('sandhills.tradepubwebsite.mvc.auction')}
                                            />
                                        </>
                                        :
                                        <>
                                            {alertData.EmailAlertsForSale && <span>{translator.translate('sandhills.tradepubwebsite.mvc.retail')},&nbsp;</span>}
                                            {alertData.EmailAlertsForAuction && <TranslationText tKey='sandhills.tradepubwebsite.mvc.auction' />}
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </>
        )
    }

    return (
        <>
            <div className='email-alert' key={props.id} id={props.id}>
                <div className='alert-table-data-row'>
                    {!windowSize.isMobile &&
                        <>
                            {alertData?.WantToBuyMessageID && !editAlert ?
                                <div className='alert-main-display'>
                                <label className='visually-hidden' htmlFor={alertData?.WantToBuyMessageID + '-email-alert'}>{translator.translate('Sandhills.SelectEmailAlert')}</label>
                                    <input id={alertData?.WantToBuyMessageID + '-email-alert'} type='checkbox' className='email-alerts__alert-checkbox' checked={props.alertsToDelete.includes(props.WantToBuyMessageID)} onClick={() => props.addAlertToDeletion(props.WantToBuyMessageID)} />
                                </div>
                                :
                                <></>
                            }
                        </>
                    }
                    
                    {siteHasClassifications ? classificationBasedFields() : nonClassificationFields()}
                    
                    {!siteHasClassifications && windowSize.isMobile && <>{iconButtons()}</>
                    }
                </div>
            </div>
        </>
    )
};

export default EmailAlertsInputForm;